import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import UploadFile from 'components/atoms/UploadFile';
import { baseURLVersionOne } from 'services/mainVersionOneService';
import { RootState } from 'types';
import { ActionsType } from 'types/system';
import { translate } from 'utils/translate';

interface UploadUpdateModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    id?: string;

    //unused props
    data: any;
    actions: ActionsType | undefined;
}

interface UploadUpdateModelState {
    //unused state
    errors: object;

    //unused state
    data: any | null;
}

class UploadUpdateModel extends Component<UploadUpdateModelProps, UploadUpdateModelState> {
    constructor(props: UploadUpdateModelProps) {
        super(props);
        this.state = {
            data: null,
            errors: {},
        };
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4   rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Upload update')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <FormGroup required={false}>
                        <UploadFile url={`${baseURLVersionOne}admin/updateFrontEnd`} acceptedFiles=".zip"></UploadFile>
                    </FormGroup>

                    <div className="flex justify-end">
                        <div className="mt-5">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const helpVideosModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
});

const helpVideosModelDispatchToProps = () => ({});

export default connect(helpVideosModelStateToProps, helpVideosModelDispatchToProps)(UploadUpdateModel);
